import React from 'react';
import { Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { setActivationState } from '@store/policies/schedule/actions';
import { formModes } from '@store/policies/schedule/formReducer';
import { actOptions, policyAction } from '@store/policies/schedule/utils';
import { FieldWrapper, ActivationWrapper } from './styled';

function ActivationRadio({ type = policyAction.activate }) {
  const dispatch = useDispatch();
  const { mode, activationState } = useSelector(formViewSelector);

  const handleRadioChange = (e) => {
    dispatch(setActivationState(e.target.value));
  };

  const disabled = mode === formModes.delete;

  return (
    <FieldWrapper>
      <ActivationWrapper>
        <div>{type === policyAction.reorder ? 'Reorder Time' : 'Policy Activation Time'}</div>
        <Radio.Group
          value={activationState}
          defaultValue={activationState}
          buttonStyle="solid"
          onChange={handleRadioChange}
          disabled={disabled}
        >
          <Radio.Button value={actOptions.now}>
            {type === policyAction.reorder ? 'Reorder Now' : 'Activate Now'}
          </Radio.Button>
          <Radio.Button value={actOptions.schedule}>Schedule</Radio.Button>
        </Radio.Group>
      </ActivationWrapper>
    </FieldWrapper>
  );
}

export default React.memo(ActivationRadio);
